import logger from '~/config/app.logger';
import { GET_ADMIN_USER_ROLES_ENDPOINT, LOGGER_NAME } from '../config/constants';
import { getExtendedLogger } from '@mindtickle/ui-shell-core/Logger';
//@ts-ignore
import { get } from '@mindtickle/api-helpers';
import type { TLocalAuthContext } from '~/components/Auth';

const log = getExtendedLogger(LOGGER_NAME, logger);

type CanLoadFreshchatProps = {
  isAdmin: boolean;
  auth: TLocalAuthContext | undefined;
};

const getAdminRoles = async (companyId: string): Promise<string[]> => {
  if (!companyId) return [];

  try {
    const response = await get(
      {
        url: `${GET_ADMIN_USER_ROLES_ENDPOINT}?cname=${companyId}`,
      },
      {
        cacheOptions: 'ttl=1800000; type=session; cacheId=GET_ADMIN_USER_ROLES;',
      }
    );
    return response?.admin_user_roles || [];
  } catch (error) {
    log('Error fetching admin roles', error, companyId, 'Unable to access Freshchat.');
    return [];
  }
};

export const userHasAdminAccess = async (
  userRoles: string[] | undefined = [],
  companyId: string | undefined = ''
): Promise<boolean> => {
  const adminRoles = await getAdminRoles(companyId);
  return userRoles.some(role => adminRoles.includes(role));
};

const canLoadFreshchat = async ({ isAdmin, auth }: CanLoadFreshchatProps): Promise<boolean> => {
  if (!isAdmin) return false;
  const hasAdminAccess = await userHasAdminAccess(auth?.user?.roles, auth?.company?.id);
  return hasAdminAccess;
};

export default canLoadFreshchat;
